import { VectorProps } from '../types/vectors';

const LogoDW = ({
  size = '32px',
  primary = '#316293',
  secondary = '#fff',
}: VectorProps) => (
  <svg width={size} viewBox="0 0 61.95 61.95" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path fill={primary} d="M30.98,59.68c-15.83,0-28.71-12.88-28.71-28.71S15.15,2.27,30.98,2.27s28.71,12.88,28.71,28.71-12.88,28.71-28.71,28.71Z"/>
      <path fill={primary} d="M30.98,4.53c14.6,0,26.44,11.84,26.44,26.44s-11.84,26.44-26.44,26.44S4.53,45.58,4.53,30.98,16.37,4.53,30.98,4.53M30.98,0C13.9,0,0,13.9,0,30.98s13.9,30.98,30.98,30.98,30.98-13.9,30.98-30.98S48.05,0,30.98,0h0Z"/>
    </g>
    <g>
      <path fill={secondary} d="M16.4,47.82c-.58,0-1.16-.22-1.6-.66-.89-.89-.89-2.32,0-3.21l29.15-29.15c.89-.89,2.32-.88,3.21,0,.89.89.89,2.32,0,3.21l-29.15,29.15c-.44.44-1.02.66-1.6.66Z"/>
      <path fill={secondary} d="M28.11,24.78c-.58,0-1.16-.22-1.6-.66l-8.64-8.64c-.89-.89-.89-2.32,0-3.21.89-.89,2.32-.89,3.21,0l8.64,8.64c.89.89.89,2.32,0,3.21-.44.44-1.02.66-1.6.66Z"/>
      <path fill={secondary} d="M51.68,21.61c-.89-.89-2.32-.89-3.21,0l-10.63,10.63c-.89.89-.89,2.32,0,3.21l8.64,8.64c.44.44,1.02.66,1.6.66s1.16-.22,1.6-.66c.89-.89.89-2.32,0-3.21l-7.03-7.03,9.03-9.03c.89-.89.89-2.32,0-3.21Z"/>
      <path fill={secondary} d="M42.4,50.4c-.58,0-1.16-.22-1.6-.66l-8.62-8.62c-.89-.89-.89-2.32,0-3.21.89-.89,2.32-.89,3.21,0l8.62,8.62c.89.89.89,2.32,0,3.21-.44.44-1.02.66-1.6.66Z"/>
      <path fill={secondary} d="M24.04,26.57l-8.62-8.62c-.89-.89-2.32-.89-3.21,0-.89.89-.89,2.32,0,3.21l7.02,7.02-8.96,8.96c-.89.89-.89,2.32,0,3.21.44.44,1.02.66,1.6.66s1.16-.22,1.6-.66l10.56-10.56c.89-.89.89-2.32,0-3.21Z"/>
    </g>
  </svg>
);

export default LogoDW;
